import Vue from 'vue'
import { MoyenPaiement } from '@/enum/MoyenPaiement'
import { TypeReduction } from '@/enum/TypeReduction'

Vue.filter('typeReduction', function(value: TypeReduction ) {
  if (value) {
    switch(value){       
      case TypeReduction.montant:
        return 'Montant fixe'
      case TypeReduction.pourcentage:
        return 'Pourcentage'      
    }            
  }
  return ''
})